// Data Service Router
// isDemoMode controls auth bypass (skip login wall)
// Data source: use Firebase when configured, fall back to local simulation

import demoDataService from './demoDataService';
import realtimeDataService from './realtimeDataService';

// isDemoMode = true → skip auth, used by App.jsx for MockAuthProvider
export const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true' ||
  !import.meta.env.VITE_FIREBASE_PROJECT_ID;

// Data source: prefer Firebase if project is configured (demo.py pushes there)
const hasFirebase = !!import.meta.env.VITE_FIREBASE_PROJECT_ID;
const dataService = hasFirebase ? realtimeDataService : demoDataService;

console.log(`[DataService] Data: ${hasFirebase ? 'Firebase' : 'Local simulation'} | Auth: ${isDemoMode ? 'Skipped' : 'Required'}`);

export default dataService;
